import { useEffect, useState, useCallback } from "react";

export const CALIBRATION_LOG_KEY = "CALIBRATION_LOG";

export default function useCalibrationLog(
  tabKey?: string
): [string[] | undefined, (value: string, runningTabKey: string) => void] {
  const getInitialLog = useCallback(() => {
    const localLog = localStorage.getItem(CALIBRATION_LOG_KEY);
    if (tabKey && localLog) {
      const dataLog = JSON.parse(localLog);
      return dataLog[tabKey] || [];
    }
    return [];
  }, [tabKey]);

  const [logMessages, setLogMessages] = useState<string[]>(getInitialLog);

  useEffect(() => {
    setLogMessages(getInitialLog);
  }, [tabKey, getInitialLog, localStorage.getItem(CALIBRATION_LOG_KEY)]);

  const customCb = useCallback((value: string, runningTabKey: string) => {
    const localLog = localStorage.getItem(CALIBRATION_LOG_KEY);
    const dataLog = localLog ? JSON.parse(localLog) : {};
    const currentLogMessages = dataLog[runningTabKey] || [];

    if (
      currentLogMessages.length &&
      currentLogMessages[currentLogMessages.length - 1] === value
    ) {
      return;
    }

    const updatedLogMessages = [...currentLogMessages, value];
    dataLog[runningTabKey] = updatedLogMessages;
    localStorage.setItem(CALIBRATION_LOG_KEY, JSON.stringify(dataLog));
    setLogMessages(updatedLogMessages);
  }, []);

  return [logMessages, customCb];
}
